import React, { useState } from "react";
import { Button } from "@mantine/core";
import { FaCircleCheck, FaBan } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";

/**
 * NOTE:
 *  - No notifications here (to avoid duplicates). The parent page shows one popup.
 *  - No window events; we rely on the parent callbacks.
 */
const TableActions = ({ requestId, onApproveSuccess, onApproveError }) => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleChangeStatus = async (status) => {
    if (submitting) return;
    const token = localStorage.getItem("token");
    if (!token || !requestId) {
      // pass context so parent can render appropriate message
      onApproveError?.(status);
      return;
    }

    const endpoint =
      status === "Approved"
        ? `${API_BASE_URL}/api/approvals/${requestId}/approve`
        : `${API_BASE_URL}/api/approvals/${requestId}/reject`;

    try {
      setSubmitting(true);
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });

      if (!res.ok) {
        if (res.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
          return;
        }
        // let parent know which action failed
        onApproveError?.(status);
        return;
      }

      // pass the status so parent shows the correct popup
      onApproveSuccess?.(status);
    } catch (err) {
      onApproveError?.(status);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="flex flex-row items-center gap-2"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Button
        type="button"
        radius="md"
        disabled={submitting}
        onClick={() => handleChangeStatus("Rejected")}
        className="text-black shadow-md text-sm font-MTNfont bg-[#FFCC00] hover:bg-[#e6b800] transition-colors duration-200
                   w-auto px-4 py-1 leading-tight"
        leftIcon={<FaBan size={16} />}
      >
        {submitting ? "Working..." : "Reject"}
      </Button>

      <Button
        type="button"
        radius="md"
        disabled={submitting}
        onClick={() => handleChangeStatus("Approved")}
        className="text-black shadow-md text-sm font-MTNfont bg-[#FFCC00] hover:bg-[#e6b800] transition-colors duration-200
                   w-auto px-4 py-1 leading-tight"
        leftIcon={<FaCircleCheck size={16} />}
      >
        {submitting ? "Working..." : "Approve"}
      </Button>
    </div>
  );
};

export default TableActions;
